/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getStreetList = (payload, callback) =>
  req.list(
    c.GET_STREETS,
    'api/v1/rpt/administrator/settings/streets',
    payload,
    callback
  );

export const getSingleStreet = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_STREET,
    `api/v1/rpt/administrator/settings/streets/${id}`,
    payload,
    callback
  );

export const createStreet = (payload, callback) =>
  req.create(
    c.CREATE_STREET,
    'api/v1/rpt/administrator/settings/streets',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateStreet = (id, payload, callback) =>
  req.update(
    c.UPDATE_STREET,
    `api/v1/rpt/administrator/settings/streets/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeStreet = (id, payload, callback) =>
  req.remove(
    c.REMOVE_STREET,
    `api/v1/rpt/administrator/settings/streets/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

  export const getLocationList = (payload, callback) =>
  req.list(
    c.GET_LOCATION_LIST,
    'api/v1/rpt/administrator/settings/locations',
    payload,
    callback
  );


